'use client';

import cx from 'classnames';

import { flattenCollection } from '~/contentful/utils/collection';
import { Column, Grid } from '~/ui/components/grid';
import { ContentGrid, type ContentGridProps } from '~/ui/modules/content-grid';
import { Newsletter } from '~/ui/modules/newsletter';
import { Breakpoint } from '~/ui/styles/grid';
import spacingStyles from '~/ui/styles/spacing.module.scss';
import typographyStyles from '~/ui/styles/typography.module.scss';

import styles from './page.module.scss';
import { type getEventsPage } from './query';

export interface UpcomingEventsSectionProps
  extends Pick<
    Awaited<ReturnType<typeof getEventsPage>>,
    'upcomingEventsCollection' | 'newsletter'
  > {}

export function UpcomingEventsSection({
  upcomingEventsCollection,
  newsletter,
}: UpcomingEventsSectionProps) {
  const upcomingEvents = flattenCollection(upcomingEventsCollection);

  if (upcomingEvents.length === 0) {
    return (
      <Grid className={spacingStyles.section}>
        <Column
          span={{ [Breakpoint.TABLET]: 4, [Breakpoint.DESKTOP]: 4 }}
          offsetLeft={{ [Breakpoint.DESKTOP]: 1 }}
        >
          <p className={cx(typographyStyles.bodySmall, styles.noEvents)}>
            There are currently no upcoming events
          </p>
        </Column>
        {newsletter ? (
          <Newsletter.Column hasSibling>
            <Newsletter newsletter={newsletter} />
          </Newsletter.Column>
        ) : null}
      </Grid>
    );
  }

  const items: ContentGridProps['items'] = [...upcomingEvents];
  if (newsletter) {
    items.push(
      <Newsletter.Column hasSibling key={0}>
        <Newsletter newsletter={newsletter} />
      </Newsletter.Column>,
    );
  }

  return <ContentGrid title="Upcoming events" items={items} className={spacingStyles.section} />;
}
